import { FormattedMessage } from 'react-intl';
import { forwardRef } from 'react';
import Button from '@mui/material/Button';

import { ErrorSnackbar, ErrorSnackbarProps } from './error-snackbar';

export const FatalErrorSnackbar = forwardRef<HTMLDivElement, ErrorSnackbarProps>((props, ref) => {
    const handleReload = (): void => {
        window.location.reload();
    };

    return (
        <ErrorSnackbar {...props} ref={ref}>
            <Button variant="text" color="light" onClick={handleReload}>
                <FormattedMessage id="app.error.action.reload" />
            </Button>
        </ErrorSnackbar>
    );
});
